import React, { FC } from 'react';

import styled from 'styled-components';

import Markdown from '@components/utils/Markdown';
import { Separator } from '@components/formStyles';

const Container = styled.div`
  width: 100%;
  height: auto;
  padding: 40px 38px 40px 40px;
  border-radius: 2px;
  color: ${({ theme }) => theme.palette.darkGrey};
  box-shadow: 0 10px 20px 0 rgba(58, 58, 58, 0.1);
  position: relative;
  background-color: ${({ theme }) => theme.palette.white};
  @media ${({ theme }) => `(max-width: ${theme.breakPoint.LARGE_1X})`} {
    margin: 20px 0;
    padding: 23px 15px 20px 15px;
  }
`;

const Title = styled.h2`
  font-size: 24px;
  font-weight: bold;

  color: ${({ theme }) => theme.palette.darkGrey};
`;

interface AboutUsProps {
  description?: string;
}

const AboutUs: FC<AboutUsProps> = ({ description = '' }) => (
  <Container>
    <Title>Tur Hakkında</Title>
    <Separator />
    <Markdown text={description} />
  </Container>
);

export default AboutUs;
